import { makeStyles } from 'tss-react/mui';
import { addPadding, removePaddingWithMargin } from '../../styles/jss/utils';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    floristMapContainer: Object.assign(Object.assign({ height: '300px', marginBottom: spacing.xs }, removePaddingWithMargin), { [theme.breakpoints.up('md')]: Object.assign({ height: '400px', marginBottom: spacing.xl }, addPadding) }),
    floristGalleryContainer: {
        display: 'grid',
        width: '100%',
        gridTemplateColumns: 'repeat(1, 1fr)',
        gridRowGap: spacing.xs,
        marginBottom: spacing.medium,
        [theme.breakpoints.up('sm')]: {
            gridTemplateColumns: 'repeat(2, 1fr)',
            gridColumnGap: spacing.small,
            gridRowGap: spacing.small,
            marginBottom: spacing.medium,
        },
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridColumnGap: spacing.medium,
            gridRowGap: spacing.medium,
            marginBottom: spacing.xl,
        },
        '&:last-child': {
            marginBottom: '0px',
        },
    },
    searchMoreButtonContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& button': {
            width: '100%',
            [theme.breakpoints.up('md')]: {
                width: 'initial',
            },
        },
    },
    searchMoreButton: {},
}));
export default useStyles;
